import viewMixin from '../../../components/core/consumers/viewMixin';
import ApiService from '../../../services/apiService';
import { userItemsPerListMixin } from '../../../utils/vuex';
import cloneDeep from 'lodash/cloneDeep';
import { mapState } from 'vuex';
const emptyModel = {
  transformer: {
    definition: '$.value',
    type: 'jsonata',
    contentTypes: {}
  },
  properties: {}
};
const defaultItemsPerPage = 10;
const defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'ViewConnectorsConsumersTransformers',
  mixins: [viewMixin, userItemsPerListMixin],
  data() {
    return {
      searchItem: '',
      selectedAccounts: [],
      accounts: [],
      selectedAccount: null,
      loadingAccounts: true,
      transformerTypes: ['jsonata', 'javascript'],
      transformerModel: cloneDeep(emptyModel),
      deletePrompt: false,
      deleteItemId: null,
      tableOptions: defaultTableOptions
    };
  },
  computed: {
    ...mapState('authentication', ['tenantId']),
    hasNoTransformers() {
      return this.transformers.length === 0;
    },
    inputTypes() {
      switch (this.transformerModel.transformer.type) {
        default:
          return ['application/json', 'text/plain', 'generic'];
      }
    },
    outputTypes() {
      switch (this.transformerModel.transformer.type) {
        default:
          return ['application/json', 'text/plain', 'generic'];
      }
    },
    showCodeMirror() {
      // return this.transformerModel.transformer.type === 'jsonata';
      return true;
    },
    tableLocalizations() {
      return {
        headers: [{
          text: this.$i18n_t('Connectors.Filter.table.id'),
          value: 'id',
          align: 'center'
        }, {
          text: this.$i18n_t('Connectors.Filter.table.name'),
          value: 'name',
          align: 'start'
        }, {
          text: this.$i18n_t('Connectors.Filter.table.type'),
          sortable: true,
          value: 'transformer.type',
          align: 'start'
        }, {
          text: this.$i18n_t('Connectors.Filter.table.outputType'),
          sortable: true,
          value: 'transformer.contentTypes.output'
        }, {
          text: this.$i18n_t('NiotaClassic.Common.table.account'),
          value: 'tenantId'
        }, {
          text: this.$i18n_t('Connectors.Filter.table.createdAt'),
          value: 'createdAt'
        }, {
          value: 'actions',
          align: 'end'
        }],
        footerProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [10, 20, 50]
        }
      };
    }
  },
  watch: {
    selectedAccounts() {
      this.fetchTransformers(this.selectedAccounts);
    },
    inputTypes() {
      if (this.inputTypes.length === 1 || this.inputTypes.indexOf(this.transformerModel.transformer.contentTypes.input) < 0) {
        this.transformerModel.transformer.contentTypes.input = this.inputTypes[0];
      }
    },
    outputTypes() {
      if (this.outputTypes.length === 1 || this.outputTypes.indexOf(this.transformerModel.transformer.contentTypes.output) < 0) {
        this.transformerModel.transformer.contentTypes.output = this.outputTypes[0];
      }
    },
    'transformerModel.transformer.type'() {
      switch (this.transformerModel.transformer.type) {
        case 'jsonata':
          this.transformerModel.transformer.definition = '$.value';
          break;
        case 'javascript':
          this.transformerModel.transformer.definition = 'return x.value';
          break;
      }
    }
  },
  created() {
    this.fetchAccounts();
  },
  methods: {
    openEdit(item = null) {
      if (!item) {
        this.selectedAccount = null;
        this.$router.push('/connectors/consumers/transformers/create');
      } else {
        this.selectedAccount = this.accounts.find(acc => acc.id === item.tenantId);
        this.$router.push(`/connectors/consumers/transformers/${item.id}`);
      }
    },
    save() {
      let promise = null;
      if (this.transformerModel.id) {
        promise = ApiService.consumerTransformersUpdate(this.transformerModel.id, this.transformerModel);
      } else {
        promise = ApiService.consumerTransformersCreate(this.selectedAccount, this.transformerModel);
      }
      promise.then(() => {
        this.fetchTransformers();
        this.closeDialog();
      }).catch(e => {
        this.$snack(e.response.data.message, 'error');
      });
    },
    showDeletePrompt(id) {
      this.deleteItemId = id;
      this.deletePrompt = true;
    },
    deleteTransformer(id) {
      ApiService.consumerTransformersDelete(id).then(() => {
        this.fetchTransformers(this.selectedAccounts);
      }).catch(error => {
        this.$snack(error.response.data.message, 'error');
      }).finally(() => {
        this.deletePrompt = false;
      });
    },
    fetchAccounts() {
      this.$store.dispatch('app/loadAccounts').then(accounts => {
        this.accounts = accounts;
      }).catch(error => {
        console.error(error);
        this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.errorFindingAccounts'), 'error');
      });
    }
  }
};